import L from 'leaflet';

/**
 * Default Leaflet marker icon configuration.
 * Fixes missing icons when using Leaflet with bundlers.
 */
export const defaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

/**
 * Initialize Leaflet default marker icon.
 * Call this once when using Leaflet maps.
 */
export function initLeafletIcon(): void {
  L.Marker.prototype.options.icon = defaultIcon;
}

/**
 * Parse a geopoint string "lat,lng" into coordinates.
 * @returns [lat, lng] tuple or null if invalid
 */
export function parseGeopoint(value: string | undefined): [number, number] | null {
  if (!value) return null;
  const [lat, lng] = value.split(',').map(Number);
  if (isNaN(lat) || isNaN(lng)) return null;
  return [lat, lng];
}

/**
 * Format coordinates as a geopoint string.
 */
export function formatGeopoint(lat: number, lng: number): string {
  return `${lat.toFixed(6)},${lng.toFixed(6)}`;
}

/**
 * Calculate bounds that fit all given coordinates.
 * @returns Leaflet LatLngBounds or null if no valid coordinates
 */
export function calculateBounds(coordinates: Array<[number, number]>): L.LatLngBounds | null {
  if (coordinates.length === 0) return null;
  return L.latLngBounds(coordinates);
}

/** Default map center (London) when no coordinates available */
export const DEFAULT_CENTER: [number, number] = [51.505, -0.09];
export const DEFAULT_ZOOM = 13;
